var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildrenHouseholdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C5.1 0 6 0.9 6 2C6 3.1 5.1 4 4 4C2.9 4 2 3.1 2 2C2 0.9 2.9 0 4 0ZM13 7.5C13 8.33 13.67 9 14.5 9C15.33 9 16 8.33 16 7.5C16 6.67 15.33 6 14.5 6C13.67 6 13 6.67 13 7.5ZM16 10H13.16C12.58 10.01 12.02 10.32 11.71 10.86L10.79 12.18L7.22 6C6.85 5.37 6.19 5.01 5.51 5H2.5C1.4 5 0.5 5.9 0.5 7V12C0.5 12.55 0.95 13 1.5 13H2V19C2 19.55 2.45 20 3 20H6C6.55 20 7 19.55 7 19V9.61L9.24 13.5C9.42 13.81 9.75 14 10.11 14H11.21C11.54 14 11.84 13.84 12.03 13.57L12.5 12.9V19C12.5 19.55 12.95 20 13.5 20H15.5C16.05 20 16.5 19.55 16.5 19V15C17.05 15 17.5 14.55 17.5 14V11.5C17.5 10.68 16.83 10 16 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildrenHouseholdIcon);
export default __webpack_public_path__ + "static/media/ChildrenHouseholdIcon.9efe3efa8cb0eab7ba434fc0bc404d5c.svg";
export { ForwardRef as ReactComponent };